import React, { useState } from 'react';
import { Table, Radio, Divider } from 'antd';
import classes from "./actionPlan.module.css";
    
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        render: (text) => <a>{text}</a>,
      },
      {
        title: 'Total Action Points',
        dataIndex: 'age',
      },
      {
        title: 'Date of Audit',
        dataIndex: 'date',
      },
      {
        title: 'Location',
        dataIndex: 'address',
      },
    ];
    const data = [
      {
        key: '1',
        name: 'John Brown',
        age: 12,
        date:"10/03/2022",
        address: 'New York No. 1 Lake Park',
      },
      {
        key: '2',
        name: 'Jim Green',
        age: 2,
        date:"12/03/2022",
        address: 'London No. 1 Lake Park',
      },
      {
        key: '3',
        name: 'Joe Black',
        age: 3,
        date:"15/03/2022",
        address: 'Sidney No. 1 Lake Park',
      },
      {
        key: '4',
        name: 'Disabled User',
        age: 9,
        date:"17/03/2022",
        address: 'Sidney No. 1 Lake Park',
      },
    ]; // rowSelection object indicates the need for row selection
    
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User',
        // Column configuration not to be checked
        name: record.name,
      }),
    };
    
    const  ActionPlan = () => {
      const [selectionType, setSelectionType] = useState('checkbox');
 

  return(
    <>
    <h2>Action Plan</h2>
    <hr/>
       <div>
           {/* <Radio.Group
            onChange={({ target: { value } }) => {
              setSelectionType(value);
            }}
            value={selectionType}
          > */}
            {/* <Radio value="checkbox">Checkbox</Radio>
            <Radio value="radio">radio</Radio> */}
          {/* </Radio.Group> */}
            <h3 style={{textAlign:"center"}}> 
                List Of Audits Done Recently
                </h3> 
{/*     
          <Divider />
     */}
          <Table
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
            columns={columns}
            dataSource={data}
          />
        </div>
    </>
  );
};
export default ActionPlan; 

